import { Action } from "redux";
import { VenueTag } from "../../../model/VenueTag";

export const GET_TAGS_FOR_ORGANIZATION_SUCCESS =
  "GET_TAGS_FOR_ORGANIZATION_SUCCESS";

export interface GetTagsForOrganizationSuccessAction extends Action {
  type: "GET_TAGS_FOR_ORGANIZATION_SUCCESS";
  organization: string;
  tags: VenueTag[];
}

export const getTagsForOrganizationSuccessAction = (
  organizationKeyName: string,
  tags: VenueTag[]
): GetTagsForOrganizationSuccessAction => ({
  type: GET_TAGS_FOR_ORGANIZATION_SUCCESS,
  organization: organizationKeyName,
  tags,
});
